/* eslint-disable no-nested-ternary */
/* eslint-disable no-confusing-arrow */
import React from "react";
import { node, string, number } from "prop-types";
import classNames from "classnames";
// import styled from "styled-components";

const GridTableData = ({
    children,
    className,
    columnStart,
    columnWidth,
    rowStart,
    rowWidth,
    alignX,
    alignY,
    flexDirection,

    ...props
}) => (
    // const StyledTableData = styled.div`
    //     grid-column: ${() => (columnStart ? `${columnStart} / span ${columnWidth}` : "")}};
    //     grid-row: ${() => (rowStart ? `${rowStart} / span ${rowWidth}` : "")};
    //     -webkit-justify-content: ${() => `${alignX}`};
    //     justify-content: ${() => `${alignX}`};
    //     -webkit-align-items: ${() => `${alignY}`};
    //     align-items: ${() => `${alignY}`};
    //     flex-direction: ${() => `${flexDirection}`};
    //     text-align: ${() =>
    //         flexDirection === "row"
    //             ? `${
    //                   alignX === "flex-start"
    //                       ? "left"
    //                       : alignX === "flex-end"
    //                       ? "right"
    //                       : alignX === "center"
    //                       ? "center"
    //                       : alignX
    //               }`
    //             : `${
    //                   alignY === "flex-start"
    //                       ? "flex-start"
    //                       : alignY === "flex-end"
    //                       ? "flex-end"
    //                       : alignY === "center"
    //                       ? "center"
    //                       : alignY
    //               }`};
    // `;
    // SACAR ALIGNX
    <div
        style={{
            gridColumn: `${columnStart ? `${columnStart} / span ${columnWidth}` : ""}`,
            gridRow: `${rowStart ? `${rowStart} / span ${rowWidth}` : ""}`,
            justifyContent: `${alignX}`,
            alignItems: `${alignY}`,
            flexDirection: `${flexDirection}`,
            textAlign: `${
                flexDirection
                    ? alignX === "flex-start"
                        ? "left"
                        : alignX === "flex-end"
                        ? "right"
                        : alignX === "center"
                        ? "center"
                        : alignX
                    : alignY === "flex-start"
                    ? "flex-start"
                    : alignY === "flex-end"
                    ? "flex-end"
                    : alignY === "center"
                    ? "center"
                    : alignY
            }`,
        }}
        className={classNames("grid-table-data", className)}
        {...props}>
        {children}
    </div>
);
GridTableData.propTypes = {
    children: node,
    className: string,
    columnStart: number.isRequired,
    columnWidth: number,
    rowStart: number.isRequired,
    rowWidth: number,
    alignX: string,
    alignY: string,
    flexDirection: string,
};

GridTableData.defaultProps = {
    children: null,
    className: "",
    columnWidth: 1,
    rowWidth: 1,
    alignX: "",
    alignY: "",
    flexDirection: "row",
};

export default GridTableData;
